import { FC } from "react";
import { Typography } from "antd";
import { TextProps } from "antd/lib/typography/Text";

const Text: FC<TextProps> = (props) => {
  return <Typography.Text {...props} />;
};

export default Text;
